import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.default');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-layout-default',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.default/view.scss */
/* src/app/layout.default/view.scss: no such file or directory */`],
})
export class LayoutDefaultComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default LayoutDefaultComponent;